import React, { useState, useEffect, useMemo } from "react";
import { CSVLink } from "react-csv";
import api from "../../utils/api.utils";
import { useNavigate } from "react-router-dom";
import { NavbarAdmin } from "../../components/NavbarAdmin";
import { FooterAdmin } from "../../components/FooterAdmin";

import "../css/AdminHome.css";

export const RelatorioManifestacoes = ({ loading, setLoading, loadingGif }) => {
  const [ouvidorias, setOuvidorias] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedType, setSelectedType] = useState("");

  const navigate = useNavigate();

  const goToManifestacao = (ouvidoriaId) => {
    navigate(`/admin/ouvidoria/${ouvidoriaId}/`);
  };

  useEffect(() => {
    const getOuvidorias = async () => {
      try {
        const data = await api.getOuvidoriaTodas();
        setLoading(true);
        setOuvidorias(data);

        setLoading(false);
      } catch (error) {
        console.log(error, "Error to get Ouvidorias");
      }
    };
    getOuvidorias();
  }, [loading, setLoading]);

  const filterData = () => {
    return ouvidorias.filter((ouvidoria) => {
      const ouvidoriaDate = new Date(ouvidoria.createdAt);
      const start = startDate ? new Date(startDate + "T00:00:00Z") : null;
      const end = endDate ? new Date(endDate + "T23:59:59Z") : null;

      const filterByDate =
        (!start || ouvidoriaDate >= start) && (!end || ouvidoriaDate <= end);
      const filterByStatus =
        !selectedStatus || ouvidoria.status === selectedStatus;
      const filterByType = !selectedType || ouvidoria.tipo === selectedType;

      return filterByDate && filterByStatus && filterByType;
    });
  };
  const filteredData = useMemo(() => filterData(), [filterData]);
  //FUNCAO DE CONVERTER CSV

  const convertToCSV = () => {
    const filteredOuvidorias = filterData();
    const csvData = filteredOuvidorias.map((ouvidoria) => ({
      Data: new Intl.DateTimeFormat("default", {
        timeZone: "America/Sao_Paulo",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).format(new Date(ouvidoria.createdAt)),
      Protocolo: `${ouvidoria.createdAt.slice(0, 4)}OUV${
        ouvidoria.protocolo_id
      }`,
      Tipo:
        ouvidoria.tipo[0].toUpperCase() +
        ouvidoria.tipo.substring(1).replace("-", " "),
      Manifestante: ouvidoria.name || "Anônimo",
      Status:
        ouvidoria.status === "em-andamento" && ouvidoria.etapa === "usuario"
          ? "Aguardando resposta do usuário"
          : ouvidoria.status[0].toUpperCase() +
            ouvidoria.status.substring(1).replace("-", " "),
      Manifestacao: ouvidoria.details
        ? ouvidoria.details.replace(/"/g, '""')
        : "",
      Resolucao: ouvidoria.resolucao
        ? ouvidoria.resolucao.replace(/"/g, '""')
        : "",
    }));

    return csvData;
  };

  const headers = [
    { label: "Data", key: "Data" },
    { label: "Protocolo", key: "Protocolo" },
    { label: "Tipo", key: "Tipo" },
    { label: "Manifestante", key: "Manifestante" },
    { label: "Status", key: "Status" },
    { label: "Manifestação", key: "Manifestacao" },
    { label: "Resolução", key: "Resolucao" },
  ];

  let count = 0;
  let statusAtual = "";
  // console.log(filteredData)
  return (
    <div>
      <NavbarAdmin />
      <div className="container mt-3">
        <h4>
          <i className="bi bi-bar-chart-line-fill"></i> Relatórios de
          Manifestações
        </h4>
      </div>
      <hr />
      <div className="container">
        <div className="d-flex justify-content-between align-items-baseline">
          <div className="d-flex justify-content-end">
            {/* Campos de filtro por período */}
            <div className="form-group">
              <label>Data de Início: </label>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="form-group mx-3">
              <label>Data de Término: </label>
              <input
                type="date"
                value={endDate}
                className="form-control"
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Tipo: </label>
              <select
                value={selectedType}
                className="form-control custom-select"
                onChange={(e) => setSelectedType(e.target.value)}
              >
                <option value="">Todos</option>
                <option value="reclamações">Reclamações</option>
                <option value="sugestões">Sugestões</option>
                <option value="elogios">Elogios</option>
                {/* Adicione outras opções conforme necessário */}
              </select>
            </div>
            {/* Campo de filtro por status */}
            <div className="form-group mx-3">
              <label>Status: </label>
              <select
                value={selectedStatus}
                className="form-control custom-select"
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="">Todos</option>
                <option value="em-andamento">Em Andamento</option>
                <option value="finalizada-procedente">
                  Finalizada procedente
                </option>
                <option value="finalizada-improcedente">
                  Finalizada improcedente
                </option>
                <option value="finalizada-dados-insuficientes">
                  Finalizada Dados insuficientes
                </option>
                <option value="cadastrada">Cadastrada</option>

                {/* Adicione outras opções conforme necessário */}
              </select>
            </div>
          </div>
          <div className="d-flex">
            {/* Botão de exportação CSV */}
            <CSVLink
              data={convertToCSV()}
              headers={headers}
              filename={`manifestacoes_${startDate}_${endDate}.csv`}
              className="btn btn-success text-light"
            >
              <i className="bi bi-cloud-download"></i> Exportar
            </CSVLink>
          </div>
        </div>
        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Data</th>
              <th scope="col">Protocolo</th>

              <th scope="col" className="no-mobile">
                Tipo
              </th>
              <th scope="col" className="no-mobile">
                Manifestante
              </th>

              <th scope="col">Manifestação</th>
              <th scope="col">Resolução</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            {!loading ? (
              filteredData.map((ouvidoria, index) => {
                if (
                  ouvidoria.status === "em-andamento" &&
                  ouvidoria.etapa === "usuario"
                ) {
                  statusAtual = "Aguardando resposta do usuário";
                } else {
                  statusAtual =
                    ouvidoria.status[0].toUpperCase() +
                    ouvidoria.status.substring(1).replace("-", " ");
                }
                let anoOuv = ouvidoria.createdAt.slice(0, 4);
                count++;

                if (ouvidoria.tipo === "reclamacoes")
                  ouvidoria.tipo = "reclamações";
                if (ouvidoria.tipo === "sugestoes")
                  ouvidoria.tipo = "sugestões";

                return (
                  <tr
                    key={index}
                    className="clickable"
                    onClick={() => goToManifestacao(ouvidoria._id)}
                  >
                    <th scope="row">{count}</th>
                    <td>
                      {new Intl.DateTimeFormat("default", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        // hour: "2-digit",
                        // minute: "2-digit",
                        // hour12: false,
                      }).format(new Date(ouvidoria.createdAt))}
                      {/* h */}
                    </td>
                    <td>
                      <strong>
                        {anoOuv}OUV{ouvidoria.protocolo_id}
                      </strong>
                    </td>
                    <td className="no-mobile">
                      {ouvidoria.tipo[0].toUpperCase() +
                        ouvidoria.tipo.substring(1).replace("-", " ")}
                    </td>
                    <td className="no-mobile">{ouvidoria.name || "Anônimo"}</td>
                    <td>{ouvidoria.details}</td>
                    <td>{ouvidoria.resolucao}</td>
                    <td>{statusAtual}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  <img
                    style={{ width: "100px" }}
                    src={loadingGif}
                    alt="Loading gif"
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <FooterAdmin />
    </div>
  );
};
